<template>
  <el-container class="layout-wrap">
    <el-aside width="180px" class="left-nav">
      <div class="logo-title">故事管理后台</div>
      <el-menu
        :default-active="activeMenuIndex"
        router
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        style="border-right: none"
      >
        <el-menu-item index="/assets">
          <i class="el-icon-collection"></i>
          <span slot="title">资产列表</span>
        </el-menu-item>
        <el-menu-item index="/story-plays">
          <i class="el-icon-reading"></i>
          <span slot="title">剧情播放</span>
        </el-menu-item>
        <el-menu-item index="/levels">
          <i class="el-icon-collection-tag"></i>
          <span slot="title">关卡列表</span>
        </el-menu-item>
        <el-menu-item index="/episodes">
          <i class="el-icon-film"></i>
          <span slot="title">分集列表</span>
        </el-menu-item>
        <el-menu-item index="/mini-games">
          <i class="el-icon-position"></i>
          <span slot="title">小游戏管理</span>
        </el-menu-item>
        <el-menu-item index="/third-party-games">
          <i class="el-icon-connection"></i>
          <span slot="title">三方游戏管理</span>
        </el-menu-item>
        <el-menu-item index="/image-tasks">
          <i class="el-icon-picture-outline"></i>
          <span slot="title">生成任务</span>
        </el-menu-item>
        <el-menu-item index="/tts">
          <i class="el-icon-microphone"></i>
          <span slot="title">语音合成</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/system">
          <i class="el-icon-setting"></i>
          <span slot="title">系统管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/system-settings">
          <i class="el-icon-s-tools"></i>
          <span slot="title">系统设置</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/users">
          <i class="el-icon-user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/user-analysis">
          <i class="el-icon-data-line"></i>
          <span slot="title">用户分析</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/leaderboard">
          <i class="el-icon-medal"></i>
          <span slot="title">排行榜管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header height="60px" class="app-header">
        <div class="header-title">{{ headerTitle }}</div>
        <div class="header-right">
          <span class="build-version">{{ buildTime }}</span>
          <div class="header-user-info">
          <el-dropdown @command="handleUserCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-user" style="margin-right: 6px"></i>
              <span class="user-dropdown-text">
                <span>{{ currentUser.username }}</span>
                <span class="current-novel-text">{{ currentNovelName }}</span>
              </span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>小说切换</el-dropdown-item>
              <el-dropdown-item
                v-for="item in novels"
                :key="item.novel_key"
                :command="`switch_novel:${item.novel_key}`"
                class="novel-dropdown-item"
              >
                <div class="novel-item-inner">
                  <span class="novel-name">
                    {{ item.display_name }}
                    <span v-if="item.novel_key === currentNovelKey" class="current-indicator">（当前）</span>
                  </span>
                  <el-button
                    v-if="isAdmin"
                    type="text"
                    icon="el-icon-edit"
                    class="novel-edit-btn"
                    title="编辑名称"
                    @click.stop="handleEditNovelInDropdown(item)"
                  />
                  <el-button
                    v-if="isAdmin"
                    type="text"
                    icon="el-icon-delete"
                    class="novel-delete-btn"
                    :disabled="item.novel_key === currentNovelKey || novels.length <= 1"
                    :title="item.novel_key === currentNovelKey ? '不能删除当前正在使用的故事' : (novels.length <= 1 ? '至少需要保留一个故事' : '删除故事')"
                    @click.stop="handleDeleteNovelInDropdown(item)"
                  />
                </div>
              </el-dropdown-item>
              <el-dropdown-item divided command="create_novel">新增小说</el-dropdown-item>
              <el-dropdown-item v-if="isAdmin" command="import_json">JSON 导入</el-dropdown-item>
              <el-dropdown-item v-if="isAdmin" command="export_json">JSON 导出</el-dropdown-item>
              <el-dropdown-item divided command="trigger_update">检查更新</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      </el-header>
      <el-main class="layout-main">
        <div class="layout-router-root">
          <router-view />
        </div>
      </el-main>
    </el-container>

    <!-- JSON Import Dialog -->
    <el-dialog title="JSON 导入故事初始化" :visible.sync="importDialogVisible" width="800px" append-to-body>
      <div style="margin-bottom: 10px; color: #666; font-size: 13px;">
        请粘贴根据 <code>djson.md</code> 格式生成的 JSON 内容。导入将根据 <code>novel_key</code> 自动创建或更新资产、分集和分段。
      </div>
      <el-input
        v-model="importJsonText"
        type="textarea"
        :rows="20"
        placeholder="在此粘贴 JSON 内容..."
      />
      <div slot="footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="warning" :loading="importing" @click="handleImportJson">开始导入</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { createNovel, getNovels, deleteNovel, updateNovel, importFullJson, exportFullJson, triggerUpdate } from "@/net/api";

export default {
  name: "MainLayout",
  data() {
    return {
      novels: [],
      importDialogVisible: false,
      importJsonText: "",
      importing: false
    };
  },
  computed: {
    activeMenuIndex() {
      if (this.$route.path === "/") return "/assets";
      return this.$route.path;
    },
    currentNovelKey() {
      return localStorage.getItem("current_novel_key") || "default";
    },
    currentNovelName() {
      return localStorage.getItem("current_novel_name") || "default";
    },
    currentUser() {
      try {
        return JSON.parse(localStorage.getItem("user") || "{}");
      } catch (e) {
        return {};
      }
    },
    buildTime() {
      return __BUILD_TIME__;
    },
    isAdmin() {
      return this.currentUser.role === "admin";
    },
    headerTitle() {
      const titles = {
        "/assets": "资产管理",
        "/episodes": "分集与剧情管理",
        "/image-tasks": "AI 生成任务",
        "/story-plays": "剧情播放管理",
        "/story-plays/:id/edit": "编辑剧情",
        "/levels": "关卡列表",
        "/system": "系统管理",
        "/system-settings": "系统设置",
        "/users": "用户权限管理",
        "/user-analysis": "用户分析",
        "/leaderboard": "排行榜管理",
        "/mini-games": "小游戏管理",
        "/mini-game-resources": "资源配置",
        "/mini-games/:id/levels": "关卡选择",
        "/tts": "语音合成 (豆包)"
      };
      const path = this.$route.path;
      if (this.$route.name === "miniGameLevels") return "关卡选择";
      if (path === "/third-party-games") return "三方游戏管理";
      return titles[path] || "后台管理";
    }
  },
  created() {
    this.loadNovels();
  },
  methods: {
    async loadNovels() {
      try {
        const { data } = await getNovels();
        this.novels = Array.isArray(data) ? data : [];
        if (!localStorage.getItem("current_novel_key")) {
          const current = this.novels.find((item) => item.is_current) || this.novels[0];
          if (current) {
            localStorage.setItem("current_novel_key", current.novel_key);
            localStorage.setItem("current_novel_name", current.display_name);
          }
        }
      } catch (e) {
        this.novels = [];
      }
    },
    handleUserCommand(command) {
      if (command === "create_novel") {
        this.handleCreateNovel();
      } else if (command === "import_json") {
        this.importJsonText = "";
        this.importDialogVisible = true;
      } else if (command === "export_json") {
        this.handleExportJson();
      } else if (command === "trigger_update") {
        this.handleTriggerUpdate();
      } else if (String(command).startsWith("switch_novel:")) {
        const key = String(command).split(":")[1];
        const target = this.novels.find((item) => item.novel_key === key);
        if (!target) return;
        localStorage.setItem("current_novel_key", target.novel_key);
        localStorage.setItem("current_novel_name", target.display_name);
        window.location.reload();
      } else if (command === "logout") {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("current_novel_key");
        localStorage.removeItem("current_novel_name");
        this.$router.push("/login");
      }
    },
    async handleCreateNovel() {
      try {
        const { value } = await this.$prompt("请输入小说名", "新增小说", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "例如：book2",
          inputValidator: (v) => !!(v || "").trim(),
          inputErrorMessage: "小说名不能为空"
        });
        const name = (value || "").trim();
        if (!name) return;
        const { data } = await createNovel({ display_name: name });
        localStorage.setItem("current_novel_key", data.novel_key);
        localStorage.setItem("current_novel_name", data.display_name);
        window.location.reload();
      } catch (e) {
        if (e !== "cancel") {
          const message = e.response && e.response.data && e.response.data.message;
          this.$message.error(message || "新增小说失败");
        }
      }
    },
    async handleEditNovelInDropdown(novel) {
      try {
        const { value } = await this.$prompt("请输入新的故事名称", "编辑名称", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: novel.display_name,
          inputPattern: /\S+/,
          inputErrorMessage: "名称不能为空"
        });
        if (value && value.trim() !== novel.display_name) {
          await updateNovel(novel.novel_key, { display_name: value.trim() });
          this.$message.success("修改成功");
          if (this.currentNovelKey === novel.novel_key) {
            localStorage.setItem("current_novel_name", value.trim());
            window.location.reload();
          } else {
            this.loadNovels();
          }
        }
      } catch (e) {
        if (e !== "cancel") {
          this.$message.error(e.response?.data?.message || "修改失败");
        }
      }
    },
    async handleDeleteNovelInDropdown(novel) {
      try {
        await this.$confirm(
          `确定要彻底删除故事 "${novel.display_name}" 吗？此操作不可恢复！`,
          "删除故事",
          {
            confirmButtonText: "确定删除",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
        await deleteNovel(novel.novel_key);
        this.$message.success("删除成功");
        if (this.currentNovelKey === novel.novel_key) {
          localStorage.removeItem("current_novel_key");
          localStorage.removeItem("current_novel_name");
          window.location.reload();
        } else {
          this.loadNovels();
        }
      } catch (e) {
        if (e !== "cancel") {
          this.$message.error(e.response?.data?.message || "删除失败");
        }
      }
    },
    async handleImportJson() {
      if (!this.importJsonText.trim()) {
        this.$message.warning("请输入 JSON 内容");
        return;
      }
      let payload;
      try {
        payload = JSON.parse(this.importJsonText);
      } catch (e) {
        this.$message.error("JSON 格式错误，请检查");
        return;
      }

      this.importing = true;
      try {
        await importFullJson(payload);
        this.$message.success("导入成功");
        this.importDialogVisible = false;
        this.importJsonText = "";
        // If the imported novel is the current one or a new one, it's best to reload to refresh all data
        window.location.reload();
      } catch (e) {
        const msg = e.response?.data?.message || "导入失败";
        this.$message.error(msg);
      } finally {
        this.importing = false;
      }
    },
    async handleExportJson() {
      try {
        const { data } = await exportFullJson();
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${data.novel_key || "story"}_export.json`;
        link.click();
        URL.revokeObjectURL(url);
        this.$message.success("导出成功");
      } catch (e) {
        this.$message.error("导出失败");
      }
    },
    async handleTriggerUpdate() {
      try {
        await this.$confirm(
          "确认触发更新标记？此操作将在服务器上生成更新标记文件。",
          "检查更新",
          {
            confirmButtonText: "确认更新",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
        await triggerUpdate();
        this.$message.success("更新标记已触发");
      } catch (e) {
        if (e !== "cancel") {
          this.$message.error(e.response?.data?.message || "触发更新失败");
        }
      }
    }
  }
};
</script>

<style scoped>
.layout-wrap.el-container {
  height: 100vh;
  overflow: hidden;
}
.layout-wrap.el-container > .el-container {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}
.layout-main.el-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0 !important;
  overflow: hidden !important;
  box-sizing: border-box;
}
.layout-router-root {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
.left-nav {
  background-color: #304156;
  color: #fff;
  transition: width 0.3s;
}
.logo-title {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  background-color: #2b2f3a;
  color: #fff;
}
.app-header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}
.header-title {
  font-size: 18px;
  font-weight: 500;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.build-version {
  color: #c0c4cc;
  font-size: 12px;
  white-space: nowrap;
}
.header-user-info {
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  display: inline-flex;
  align-items: center;
}
.user-dropdown-text {
  display: inline-flex;
  flex-direction: column;
  line-height: 1.2;
}
.current-novel-text {
  color: #909399;
  font-size: 12px;
}
.novel-dropdown-item {
  padding: 0 !important;
}
.novel-item-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  min-width: 160px;
}
.novel-name {
  flex: 1;
  margin-right: 10px;
}
.novel-delete-btn {
  color: #f56c6c;
  padding: 10px 0;
}
.novel-delete-btn:hover {
  color: #ff4949;
}
.novel-edit-btn {
  color: #409eff;
  padding: 10px 0;
  margin-right: 8px;
}
.novel-edit-btn:hover {
  color: #66b1ff;
}
.current-indicator {
  color: #909399;
  font-size: 12px;
}
</style>
